import { NFT, ThemeData } from 'types/index'
import { nftThemeMeta } from 'utils/theme'
import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'
import { TokenAccount } from '../utils/tokens'
import produce from 'immer'

export type MangoStore = {
  set: (x: (x: MangoStore) => void, actionName: string) => void
  themeData: ThemeData
  wallet: {
    tokens: TokenAccount[]
    nfts: {
      data: NFT[] | []
      initialLoad: boolean
      loading: boolean
    }
  }
  window: {
    width: number
    height: number
  }
}

const mangoStore = create<MangoStore>()(
  subscribeWithSelector((_set, _get) => {
    return {
      set: (fn) => _set(produce(fn), false),
      themeData: nftThemeMeta.default,
      wallet: {
        tokens: [],
        nfts: {
          data: [],
          loading: false,
          initialLoad: true,
        },
      },
      window: {
        width: 0,
        height: 0,
      },
    }
  }),
)
export default mangoStore
